import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '@services/authentification.service';
import {AlertService} from '@services/alert.service';
import {FormService} from '@services/form.service';
import {environment} from '~/environments/environment';
import {first} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {TrackingService} from '@services/tracking.service';
import {CookieService} from 'ngx-cookie-service';
import {AFFILIATE} from '@models/partner';
import * as $ from 'jquery';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
    registerForm: UntypedFormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    redirectUrl: string;
    parrain: string;
    hide = true;
    affiliate: string;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        public authenticationService: AuthenticationService,
        private alertService: AlertService,
        public formService: FormService,
        private http: HttpClient,
        private cookieService: CookieService,
        private trackingService: TrackingService,
    ) {
        // redirect to home if already logged in
        if (this.authenticationService.isLogin) {
            this.router.navigate(['/app']);
        }
    }

    ngOnInit() {
        this.parrain = this.route.snapshot.queryParams.parrain || '';

        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            username: ['', [Validators.required, Validators.email]],
            parainage: [this.parrain],
            text_password: ['', [Validators.required, Validators.minLength(8)]],
        });

        this.affiliate = this.cookieService.get('affiliate-code');
        if (this.affiliate) {
            this.registerForm.get('parainage').disable();
            this.registerForm.get('parainage').setValue(this.affiliate.toUpperCase());
        }
        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/app/search/result';
        this.redirectUrl = this.route.snapshot.queryParamMap.get('redirect_uri') || '';
        this.route.queryParamMap.subscribe(queryParams => {
            this.redirectUrl = queryParams.get('redirect_uri');
        });
    }

    // convenience getter for easy access to form fields
    get f() {
        return this.registerForm.controls;
    }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            return;
        }

        this.loading = true;

        // TODO : Move to userService
        this.http.post(`${environment.apiUrl}app/user`, {
            email: this.f.username.value,
            lastname: this.f.lastName.value,
            firstname: this.f.firstName.value,
            text_password: this.f.text_password.value,
            code_parrainage: this.f.parainage.value,
        }).subscribe(
            data => {
                this.authenticationService.login(this.f.username.value, this.f.text_password.value, (this.redirectUrl !== '' && this.redirectUrl !== null ? 'extension' : 'app'))
                    .pipe(first())
                    .subscribe(
                        () => {
                            // this.alertService.success('Inscription reussi', true);
                            this.trackingService.register();
                            this.authenticationService.loadUser().subscribe(() => {
                                // Hide topbar after register, show after reload
                                this.authenticationService.currentUser.header_form = true;
                                this.cookieService.delete('affiliate-code', '/');
                                if (this.redirectUrl !== '' && this.redirectUrl !== null) {
                                    window.location.href = this.redirectUrl + '?token=' + this.authenticationService.currentUserToken;
                                } else {
                                    if (this.redirectUrl === '/app' || this.redirectUrl == null) {
                                        this.redirectUrl = '/app/search/result';
                                    }
                                    this.router.navigateByUrl(this.redirectUrl);
                                }
                            });
                        },
                    );
            },
            error => {
                console.log(error);
                if (error === 'Conflict') {
                    this.alertService.error('Inscription impossible, un compte existe avec ce mail');
                } else if (error === 'Bad Request') {
                    this.alertService.error('Formulaire invalid');
                } else if (error === 'Forbidden') {
                    this.alertService.error('Le code parrain n\'existe pas');
                } else if (error == 'Un compte existe déja avec ce mail.') {
                    this.router.navigate(['/app/login'], {queryParams: {returnUrl: this.returnUrl, forgot: 2}});
                } else {
                    this.alertService.error(error);
                }
                this.loading = false;
            });
    }

    signInWithGoogle(): void {
        const location = 'https://accounts.google.com/o/oauth2/v2/auth?client_id=' + environment.google_client_id +
            '&redirect_uri=https://www.lybox.fr/app/login&response_type=token' +
            '&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile' +
            '&state={"redirect":"https://www.lybox.fr' + this.returnUrl + '","provider":"google", "code": "' + this.f.parainage.value + '","source":"' + (this.redirectUrl !== '' && this.redirectUrl !== null ? 'extension' : 'app') + '"}';
        window.location.href = location;
    }

    signInWithFB(): void {
        const location = 'https://www.facebook.com/v8.0/dialog/oauth?client_id=' + environment.facebook_client_id +
            '&redirect_uri=https://www.lybox.fr/app/login&response_type=token&scope=email%2Cpublic_profile' +
            '&state={"redirect":"https://www.lybox.fr' + this.returnUrl + '","provider":"facebook", "code": "' + this.f.parainage.value + '","source":"' + (this.redirectUrl !== '' && this.redirectUrl !== null ? 'extension' : 'app') + '"}';
        window.location.href = location;
    }

    getAffiliate() {
        for (var i = 0; i < AFFILIATE.length; i++) {
            if (AFFILIATE[i].code.toLowerCase() === this.affiliate) {
                return AFFILIATE[i];
            }
        }
        return null;
    }

    showParrainage() {
        $('.add_parrainage').hide();
        $('.parrainage_field').show();
    }
}
